'use client'

import MaskLoading from '@component/loading/mask'
import MapboxMap from '@component/mapbox/map'
import EstimateMarker from '@component/mapbox/marker/house/estimate'
import ForRentMarker from '@component/mapbox/marker/house/rent'
import ForSaleMarker from '@component/mapbox/marker/house/sale'
import SoldMarker from '@component/mapbox/marker/house/sold'
import { find, get, map, size } from 'lodash-es'
import { useEstimateMapContext } from '../context'
// import RVMarker from '@component/mapbox/marker/house/rv'
import MapboxPolyline from '@component/mapbox/layer/polyline'
import { Fragment, useCallback, useEffect, useMemo } from 'react'
import MapViewControl from './control'
import DetailPolygon from './detailPolygon'
import SuburbPolygon from './suburbPolygon'
import SearchTypeMenu from './typeMenu'

export default function EstimateMapView() {

  const {
    coor,
    houseId,
    streetData,
    mapLoadData,
    viewedIds,
    pushViewedId,
    salePoints,
    rentPoints,
    soldPoints,
    propertyPoints,
    isLoading,
    setHoverDetailData,
    pushMarker,
    markerList,
    displayHouseCard,
    toggleDisplayCard
  } = useEstimateMapContext()
  const { lat, lng, zoom } = coor || {}
  const streetBoundaries = useMemo(() => {
    const boundaries = get(streetData, 'boundaries', [])
    if (!size(boundaries)) return
    return boundaries[0]
  }, [streetData])

  // 默认显示houseId对应卡片
  useEffect(() => {
    if (!displayHouseCard || !size(markerList)) return

    const marker = find(markerList, item => get(item, 'data.id', 0) === houseId)
    if (marker) {
      const popup = marker.getPopup()
      if (!popup.isOpen()) {
        marker.togglePopup()
      }
      marker.getElement().style.zIndex = 1
      toggleDisplayCard(false)
    }
  }, [houseId, markerList, displayHouseCard, toggleDisplayCard])

  // marker点击事件，记录已点击变黑
  const markerClickHandle = useCallback(data => pushViewedId(data.id), [pushViewedId])
  return (
    <div className='min-h-0 bone !flex flex-col'>
      {
        coor && (
          <MapboxMap
            id='estimate-map'
            lat={lat}
            lng={lng}
            zoom={zoom}
            className='relative'
            satelliteControl
            onLoad={mapLoadData}
          >
            <MapViewControl></MapViewControl>
            <SearchTypeMenu></SearchTypeMenu>
            <MaskLoading transparent loading={isLoading}></MaskLoading>
            <DetailPolygon></DetailPolygon>
            <SuburbPolygon></SuburbPolygon>
            {
              streetBoundaries && <MapboxPolyline data={streetBoundaries} id='street-boundaries'></MapboxPolyline>
            }
            {
              map(salePoints, item => (
                item.lng && item.lat && (
                  <ForSaleMarker
                    data={item}
                    active={viewedIds.includes(item.id)}
                    onClick={markerClickHandle}
                    onPopupLoaded={setHoverDetailData}
                    onPopupLeave={() => setHoverDetailData()}
                    key={item.id + item.slug}
                  ></ForSaleMarker>
                )
              ))
            }
            {
              map(rentPoints, item => (
                item.lng && item.lat && (
                  <ForRentMarker
                    data={item}
                    active={viewedIds.includes(item.id)}
                    onClick={markerClickHandle}
                    onPopupLoaded={setHoverDetailData}
                    onPopupLeave={() => setHoverDetailData()}
                    key={item.id + item.slug}
                  ></ForRentMarker>
                )
              ))
            }
            {
              map(soldPoints, item => (
                item.lng && item.lat && (
                  <SoldMarker
                    data={item}
                    active={viewedIds.includes(item.id)}
                    onClick={markerClickHandle}
                    onPopupLoaded={setHoverDetailData}
                    onPopupLeave={() => setHoverDetailData()}
                    key={item.id + item.slug}
                  ></SoldMarker>
                )
              ))
            }
            {
              map(propertyPoints, item => (
                item.lng && item.lat && (
                  <Fragment key={item.id + item.slug}>
                    {['avm', 'rv'].includes(item.type) && (
                      <EstimateMarker
                        data={item}
                        active={viewedIds.includes(item.id)}
                        onClick={markerClickHandle}
                        onPopupLoaded={setHoverDetailData}
                        onPopupLeave={() => setHoverDetailData()}
                        key={item.id + item.slug}
                        onAdded={pushMarker}
                      ></EstimateMarker>
                    )}
                    {/* {item.type === 'rv' && (
                      <RVMarker
                        data={item}
                        active={viewedIds.includes(item.id)}
                        onClick={markerClickHandle}
                        onPopupLoaded={setHoverDetailData}
                        onPopupLeave={() => setHoverDetailData()}
                        key={item.id + item.slug}
                      ></RVMarker>
                    )} */}
                    {item.type === 'sold' && (
                      <SoldMarker
                        data={item}
                        active={viewedIds.includes(item.id)}
                        onClick={markerClickHandle}
                        onPopupLoaded={setHoverDetailData}
                        onPopupLeave={() => setHoverDetailData()}
                        key={item.id + item.slug}
                      ></SoldMarker>
                    )}
                  </Fragment>
                )
              ))
            }
          </MapboxMap>
        )
      }
    </div>
  )
}